import api from "@/services/api"
import { queryClient } from "@/queryClient"
import { BASE_PRODUCTS_QUERY_KEY } from "@/services/queryKeys"

export const deleteProduct = async (
  productId: string
): Promise<unknown> => {
  const response = await api.delete(
    `/products/products/${productId}/`
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
  return response.body
}
